import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface StatCardProps {
  label: string;
  value: string | React.ReactNode;
  icon?: LucideIcon;
  iconColor?: string;
  className?: string;
  isLoading?: boolean;
}

export function StatCard({ label, value, icon: Icon, iconColor, className, isLoading = false }: StatCardProps) {
  if (isLoading) {
    return (
      <Card className={cn('px-4 py-2.5', className)}>
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0 flex-1 space-y-1.5">
            <Skeleton className="h-3.5 w-full max-w-[100px]" />
            <Skeleton className="h-6 w-full max-w-[150px]" />
          </div>
          {Icon && <Skeleton className="h-6 w-6 rounded" />}
        </div>
      </Card>
    );
  }

  return (
    <Card className={cn('px-4 py-2.5', className)}>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="truncate text-xs font-semibold text-muted-foreground" title={label}>
            {label}
          </div>
          <div className="text-xl font-semibold text-foreground">{value}</div>
        </div>
        {Icon && <Icon className={cn('w-6 h-6 shrink-0', iconColor || 'text-muted-foreground')} />}
      </div>
    </Card>
  );
}
